/**
 * Pages
 */

export {WorkshopReport} from './pages/WorkshopReport/WorkshopReport';
export {WorkshopCharts} from './pages/WorkshopReport/WorkshopCharts';
export {MercedesMraReport} from './pages/MercedesMraReport/MercedesMraReport';
export {Report5starCstar} from './pages/Report5starCstar/Report5starCstar';
export {HyundaiDbiReport} from './pages/HyundaiDbiReport/HyundaiDbiReport';
export {HondaMonthlyReport} from './pages/HondaMonthlyReport/HondaMonthlyReport';
